import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import Navigation from '../../../constants/enums/NavigationEnum'
import { Loader } from '../../components/Loader';



type NotFoundPageProps = RouteComponentProps<{}>;


class NotFoundPage extends React.PureComponent<NotFoundPageProps> {

    componentDidMount(): void {
        this.props.history.push(Navigation.GeneralPage)
    }
    public render() {
        return (
            <React.Fragment>
                <Loader />
            </React.Fragment>
        );
    }
}

export default withRouter(NotFoundPage)